import { useVisibleFieldsByProcess, useVisibleFieldsLoading } from 'store/visibleFields';
import { toVisibleFieldModelMap } from 'shared/domain/visibleField/visibleFieldsMap';
import { useMemo } from 'react';
import { useProcesses } from 'store/process';
import { IssueFieldNames } from 'shared/domain/issueForm/types/fieldNames';
import { ProcessType } from 'shared/domain/process/types/model';

export function useProcessesWithField(
  field: IssueFieldNames
): ProcessType[] {
  const { processes: userProcesses } = useProcesses();
  const visibleFieldsByProcess = useVisibleFieldsByProcess();
  const loadingVisibleFields = useVisibleFieldsLoading();

  const processes = useMemo(() => {
    if (loadingVisibleFields) return [];

    const processes: string[] = [];
    const fieldVisibilityMap = toVisibleFieldModelMap(
      visibleFieldsByProcess
    );

    Object.keys(fieldVisibilityMap).forEach((processId) => {
      if (fieldVisibilityMap[processId][field]) {
        processes.push(processId);
      }
    });
    return processes
      .map((processId) => {
        return userProcesses.find((process) => process._id === processId);
      })
      .filter((x) => x) as ProcessType[];
  }, [visibleFieldsByProcess, loadingVisibleFields, userProcesses, field]);

  return processes;
}
